

export class TemperatureOutputWithOutStatus implements ITemperatureOutputWithOutStatus {
    /** The auto-generated id of the temperature master */
    selected_temperature_id!: number;
    /** The voltage from */
    voltage_from!: number;
    /** The voltage to */
    voltage_to!: number;
    /** The temperature */
    temperature!: string;
    status!: number;

    constructor(data?: ITemperatureOutputWithOutStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selected_temperature_id = _data["selected_temperature_id"];
            this.voltage_from = _data["voltage_from"];
            this.voltage_to = _data["voltage_to"];
            this.temperature = _data["temperature"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): TemperatureOutputWithOutStatus {
        data = typeof data === 'object' ? data : {};
        let result = new TemperatureOutputWithOutStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selected_temperature_id"] = this.selected_temperature_id;
        data["voltage_from"] = this.voltage_from;
        data["voltage_to"] = this.voltage_to;
        data["temperature"] = this.temperature;
        data["status"] = this.status;
        return data; 
    }
}

export interface ITemperatureOutputWithOutStatus {
    /** The auto-generated id of the temperature master */
    selected_temperature_id: number;
    /** The voltage from */
    voltage_from: number;
    /** The voltage to */
    voltage_to: number;
    /** The temperature */
    temperature: string;
    status: number;
}

